var numeral = require('numeral')

import { axiosAuthInstance } from '../main.js'

export default {
  filters: {
    yesNo(value) {
      return value ? 'Yes' : 'No'
    },
    phoneFilter(value) {
      if (!value) return ''
      value = value.toString()
      return value
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    },
    maskedNumberFilter(value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/.(?=.{4,}$)/g, '*')
    },
    dobFilter(value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')
    },
    formatCurrency: function(dollars) {
      return numeral(dollars).format('$0,0')
    }
  },
  data: () => ({
    numberMask2: '##',
    numberMask3: '###',
    numberMask5: '#####',
    numberMask6: '######',
    numberMask9: '#########',
    numberMask12: '############',
    numberMask17: '#################',
    accountNumberRules: [
      v => !!v || 'Account Number is required',
      v => (v && v.length < 18) || 'Account Number must be at most 17 digits',
      v => (v && v.length > 5) || 'Account Number must be at least 6 digits'
    ],
    addressRules: [v => !!v || 'Street Address is required'],
    cityRules: [v => !!v || 'City is required'],
    stateMask: 'NN',
    stateRules: [
      v => !!v || 'State is required',
      v => (v && v.length == 2) || 'State abbreviation must be 2 characters'
    ],
    stateOptionalRules: [
      v =>
        v.length == 0 ||
        v.length == 2 ||
        'State abbreviation must be 2 characters'
    ],
    zipMask: '#####',
    zipCodeRules: [
      v => !!v || 'Zip Code is required',
      v => (v && v.length == 5) || 'Zip Code must be 5 digits'
    ],
    zipCodeOptionalRules: [
      v => v.length == 0 || v.length == 5 || 'Zip Code must be 5 digits'
    ],
    contactNameRules: [v => !!v || 'Contact Name is required'],
    phoneMask: '(###) ### - ####',
    phoneRules: [
      v => !!v || 'Phone is required',
      v => (v && v.length == 10) || 'Phone Number must be 10 digits'
    ],
    phoneOptionalRules: [
      v => v.length == 0 || v.length == 10 || 'Phone Number must be 10 digits'
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v =>
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(v) ||
        'E-mail must be valid'
    ],
    currencyConfig : {
      thousands: ',',
      prefix: '$',
      suffix: '',
      precision: 0,
      masked: false,
      allowBlank: false,
      min: 1,
      max: 12
    }
  }),
  methods: {
    //wrap i18n plugin to include looking for a version of msgKey by domain and falling back to 'default'
    i18n(msgKey, parms) {
      let msg = this.$i18n.t(msgKey + '.' + this.$store.getters.getDomain, 'en', parms)
      if (msg.startsWith(msgKey)) {
        msg = this.$i18n.t(msgKey + '.default', 'en', parms)
      }
      return msg
    },
    downloadAchTerms() {
      axiosAuthInstance({
        url:
          '/api/v1/ach/downloadTerms/' +
          this.$store.getters.getDealerApplication.id,
        method: 'GET',
        responseType: 'arraybuffer'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'AchTerms.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          this.notifyAxiosError(
            error,
            'There was an error downloading the ACH terms'
          )
        })
    },
    checkAndConfirmInvalidate(defaultConfirmMsg) {
      var confirmed = true
      var confirmMsg = defaultConfirmMsg
      var esigned = this.$store.getters.hasAnyoneEsigned
      if (esigned) {
        confirmMsg = this.$t('message.updateAppInvalidateWarning', {
          expireDate: this.formatDate(
            this.$store.getters.getDealerApplication.expirationDate
          )
        })
      }
      if (confirmMsg) {
        confirmed = confirm(confirmMsg)
        if (esigned && confirmed) {
          this.$store.commit('setApplicationJustInvalidated', true)
        }
      }
      return confirmed
    },
    joinWithAnd(a) {
      if (a.length > 1) {
        return a.slice(0, -1).join(', ')+' & ' + a.slice(-1);
      } else {
        return a.join()
      }
    },
    formatDate: function(val) {
      if (!val) return ''
      var offset = moment().utcOffset()
      return moment
        .utc(val)
        .utcOffset(offset)
        .format('MMM D, YYYY h:mm a')
    },
    formatDateOnly: function(val) {
      if (!val) return ''
      var offset = moment().utcOffset()
      return moment
        .utc(val)
        .utcOffset(offset)
        .format('MMM D, YYYY')
    },
    currentDateForJson() {
      return moment().format('YYYY-MM-DDTHH:mm:ss.SSS')
    },
    notifyAxiosError(axiosError, clientMsg) {
      if (
        axiosError.response &&
        (axiosError.response.status == '408' ||
          axiosError.response.status == '401')
      ) {
        this.notifyInfoAndClear('Session timed out. Please login again')
        return
      }

      if (
        axiosError.response &&
        axiosError.response.data &&
        axiosError.response.data.errorMessage
      ) {
        this.notifyError(clientMsg, axiosError.response.data.errorMessage)
      } else if (axiosError.response && axiosError.response.data) {
        this.notifyError(clientMsg, axiosError.response.data)
      } else if (axiosError.data) {
        this.notifyError(clientMsg, axiosError.message)
      } else {
        this.notifyError(clientMsg)
      }
    },
    notifyError(title, text) {
      this.$notify({
        clean: true
      })

      this.$notify({
        title: title,
        text: text,
        type: 'error',
        duration: -1
      })
    },
    notifyWarn(title, text, dur) {
      this.$notify({
        title: title,
        text: text,
        type: 'warning',
        duration: dur || 3000
      })
    },
    notifyInfoAndClear(title, text) {
      this.$notify({
        clean: true
      })

      this.$notify({
        title: title,
        text: text,
        type: 'success',
        duration: 3000
      })
    },
    notifyInfo(title, text, duration) {
      this.$notify({
        title: title,
        text: text,
        type: 'success',
        duration: duration || 3000
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/appMixins.js